module.exports = __webpack_public_path__ + "static/couple-playing-basketball-mobile.cffa7461.webp";